var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "tabs", class: _vm.custom_class }, [
    _c(
      "ul",
      { staticClass: "tabs__nav" },
      _vm._l(_vm.tabs, function (tab, idx) {
        return _c(
          "li",
          {
            key: idx,
            class: [
              "tabs__nav-item",
              { "tablet-lg-down": tab.name == "description" },
            ],
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.setActive(tab)
              },
            },
          },
          [
            _c("a", { class: { active: tab.isActive } }, [
              _vm._v(_vm._s(tab.name)),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("section", { staticClass: "tabs__content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }